import React from 'react';
import styled from 'styled-components';
export var AlertMessageType;
(function (AlertMessageType) {
    AlertMessageType[AlertMessageType["SUCCESS"] = 0] = "SUCCESS";
    AlertMessageType[AlertMessageType["INFO"] = 1] = "INFO";
    AlertMessageType[AlertMessageType["ERROR"] = 2] = "ERROR";
    AlertMessageType[AlertMessageType["GREEN_INFO"] = 3] = "GREEN_INFO";
})(AlertMessageType || (AlertMessageType = {}));
const AlertMessage = ({ type, className, isHidden, children }) => {
    return React.createElement(AlertMessageWrapper, { type: type, isHidden: isHidden, className: className }, children);
};
const AlertMessageWrapper = styled.div `

  display: ${props => props.isHidden && 'none'};

  padding: 14px 20px;
  border-radius: 4px;

  color: ${props => props.type === AlertMessageType.ERROR && props.theme.colors.textRed};
  color: ${props => props.type === AlertMessageType.INFO && props.theme.colors.textBlue};
  color: ${props => props.type === AlertMessageType.GREEN_INFO && props.theme.colors.textBlack};
  color: ${props => props.type === AlertMessageType.SUCCESS && props.theme.colors.textGreen};
  background-color: ${props => props.type === AlertMessageType.ERROR && props.theme.colors.backgroundRed};
  background-color: ${props => props.type === AlertMessageType.INFO && props.theme.colors.backgroundBlueLight};
  background-color: ${props => props.type === AlertMessageType.GREEN_INFO && props.theme.colors.backgroundLightGreen};
  background-color: ${props => props.type === AlertMessageType.SUCCESS && props.theme.colors.backgroundGreen};
`;
export default AlertMessage;
//# sourceMappingURL=AlertMessage.js.map